import { memo } from "react";
function LocalShippingOutlinedIcon({ color = "#05A792", width, height }) {
  return (
    <svg
      width= {width ?? "19"}
      height= {height ?? "12"}
      viewBox="0 0 19 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.101 3.33329H13.6537V0.666626H2.23308C1.33574 0.666626 0.601562 1.26663 0.601562 1.99996V9.33329H2.23308C2.23308 10.44 3.32619 11.3333 4.68035 11.3333C6.03451 11.3333 7.12762 10.44 7.12762 9.33329H12.0222C12.0222 10.44 13.1153 11.3333 14.4694 11.3333C15.8236 11.3333 16.9167 10.44 16.9167 9.33329H18.5482V5.99996L16.101 3.33329ZM15.6931 4.33329L17.292 5.99996H13.6537V4.33329H15.6931ZM4.68035 9.99996C4.23168 9.99996 3.86459 9.69996 3.86459 9.33329C3.86459 8.96663 4.23168 8.66663 4.68035 8.66663C5.12902 8.66663 5.49611 8.96663 5.49611 9.33329C5.49611 9.69996 5.12902 9.99996 4.68035 9.99996ZM6.49133 7.99996C6.04267 7.59329 5.40637 7.33329 4.68035 7.33329C3.95433 7.33329 3.31804 7.59329 2.86937 7.99996H2.23308V1.99996H12.0222V7.99996H6.49133ZM14.4694 9.99996C14.0208 9.99996 13.6537 9.69996 13.6537 9.33329C13.6537 8.96663 14.0208 8.66663 14.4694 8.66663C14.9181 8.66663 15.2852 8.96663 15.2852 9.33329C15.2852 9.69996 14.9181 9.99996 14.4694 9.99996Z"
      
        fill={color}
      />
    </svg>
  );
}

export default memo(LocalShippingOutlinedIcon);
